export default __webpack_public_path__ + "static/media/background.c8a507cf.jpg";